Vue.component('state-profile', {
    data: function() {
        return {
            editProfile: false,
            profileName: game.services.user.currentUser ? game.services.user.currentUser.name : '',
            currentUser: game.services.user.currentUser
        };
    },
    methods: {
        signIn: function() {
            this.$root.$emit('changeState', 'state-signin');
        },
        signOut: function() {
            game.services.user.logout();
        },
        saveProfile: function() {
            let token = Cookies.get('token');
            $('#loading-overlay').show();
            axios.post(API_URL + '/profile?token=' + token, {profileName: this.profileName}).then((res) => {
                let data = res.data;
                if (data.success) {
                    game.services.user.currentUser.name = this.profileName;
                    this.editProfile = false;
                    game.showGrowl('Profile saved successfully.', {type: 'success'});
                } else {
                    if (data.message) {
                        game.showGrowl(data.message, {type: 'danger'});
                    } else {
                        game.showGrowl('Failed to save profile.', {type: 'danger'});
                    }
                }
                $('#loading-overlay').hide();
            }, () => {
                $('#loading-overlay').hide();
                game.showGrowl('Failed to save profile.', {type: 'danger'});
            });
        }
    },
    template: `
    <div class="vertical-center">
        <div v-if="!currentUser">
            <h1><i class="fa fa-user fa-2x"></i></h1>
            <h3>Sign in to view your profile.</h3>
            <button type="button" class="app-btn app-btn-secondary" v-on:click="signIn()"><i class="fa fa-sign-in"></i> Sign In</button>
        </div>
        <div v-if="currentUser">
            <div class="app-card text-center">
                <div v-if="!editProfile">
                    <h1><i class="fa fa-user"></i> {{currentUser.name}}</h1>
                    <span title="Rank">
                        <img class="icon" src="assets/rank_icon.png">
                        <span id="rank">{{currentUser.currentRank}}</span>
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <span title="Coins">
                        <img class="icon" src="assets/money_icon.png">
                        <span id="coins">{{currentUser.coinCount}}</span>
                    </span><br>
                    <br>
                    <h3>Next Rank: {{currentUser.currentRank + 1}}</h3>
                    <div class="xp-bar">
                        <div class="xp-bar-inner">
                            {{currentUser.nextRankPercentage}}%
                        </div>
                        <div class="xp-bar-inner-fill" v-bind:style="{width: currentUser.nextRankPercentage + '%'}"></div>
                    </div>
                    <small>{{currentUser.currentXp}} XP</small>
                    <br><br>
                    <button type="button" class="app-btn app-btn-secondary" v-on:click="editProfile=true;">
                        <i class="fa fa-edit"></i> Edit Profile
                    </button>
                    <button type="button" class="app-btn app-btn-danger" v-on:click="signOut()">
                        <i class="fa fa-sign-out"></i> Sign Out
                    </button>
                </div>
                <div v-if="editProfile">
                    <h1><i class="fa fa-user"></i> Edit Profile</h1>
                    <label class="text-left">
                        Name
                        <input v-model="profileName" class="app-input" placeholder="Name">
                    </label>
                    <br>
                    <label class="text-left">
                        Email
                        <input v-model="currentUser.email" disabled="disabled" class="app-input" placeholder="Email">
                    </label>
                    <br><br>
                    <button type="button" class="app-btn app-btn-secondary" v-on:click="saveProfile">
                        <i class="fa fa-save"></i> Save
                    </button>
                    <button type="button" class="app-btn app-btn-danger" v-on:click="editProfile=false;">
                        <i class="fa fa-times"></i> Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
    `
})